/* eslint-disable react/no-unknown-property */
import { useLocale } from '@mirai/locale';
import { View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { IFRAME } from './FormPaycomet.constants';
import { L10N } from './FormPaycomet.l10n';
import * as style from './FormPaycomet.module.css';

export const FormPaycomet = ({ response, ...others }) => {
  const { translate } = useLocale();

  const [url, setUrl] = useState();

  useEffect(() => {
    if (!response) return;

    setUrl(response.configuration?.iframeUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  return (
    <View {...others} className={others.className}>
      <View
        allow="payment"
        id={IFRAME}
        sandbox="allow-top-navigation allow-scripts allow-same-origin allow-forms"
        src={url}
        tag="iframe"
        title={translate(L10N.LABEL_SECURE_PAGE)}
        className={style.iframe}
      />
    </View>
  );
};

FormPaycomet.displayName = 'Mirai:Payments:ButtonPayment:FormPaycomet';

FormPaycomet.propTypes = {
  response: PropTypes.shape({
    configuration: PropTypes.shape({
      iframeUrl: PropTypes.string,
    }),
  }),
};
